module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-og-image-e10088d86fa450b82d2123af51c68193.png";